module.exports = __webpack_public_path__ + "img/whatsapp.b61bfd5c.webp";